"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
var _cookie = require("@/utils/cookie");
var _log = require("@/utils/log");
var _hike = require("@/api/hike");
var _survey = require("@/api/survey");
var _filters = require("@/filters");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ResponseStatusReport',
  data() {
    return {
      tableLoading: false,
      reportList: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      this.tableLoading = true;
      (0, _hike.getParticipant)(token, id).then(response => {
        this.tableLoading = false;
        const participants = response.data.rows;
        const feedbackPromises = participants.map(participant => {
          return (0, _survey.getRespondentFeedback)(token, {
            hikeId: id,
            userId: participant.uuid
          });
        });
        this.tableLoading = true;
        Promise.all(feedbackPromises).then(responses => {
          (0, _log.showDebugLog)('MGH-RespondentFeedback-response', responses);
          this.tableLoading = false;
          this.reportList = responses.map(r => {
            const data = r.data;
            data.email = participants.find(participant => participant.uuid === data.uuid).email;
            return data;
          });
        }).catch(error => {
          (0, _log.showDebugLog)('MGH-RespondentFeedback-error', error);
          this.tableLoading = false;
          (0, _log.displayPopupMessage)(error, 'error');
        });
      }).catch(error => {
        this.tableLoading = false;
        (0, _log.showDebugLog)('Hike-getParticipant-API-error', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    handleDownload() {
      this.downloadLoading = true;
      Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/vendor/Export2Excel'))).then(excel => {
        const header = ['UUID', 'Participant Name', 'Participant Email', 'Is Completed', 'Completed Datetime (UTC)', 'Type', 'Email (Boss/Peer/Direct Report)', 'Is Completed (Boss/Peer/Direct Report)', 'Completed Datetime (UTC) (Boss/Peer/Direct Report)'];
        const benchmarkData = this.buildExcelData('benchmark');
        const summitData = this.buildExcelData('summit');
        excel.export_json_to_excel_with_multiple_sheets({
          sheets: [{
            name: 'Benchmark',
            header,
            data: benchmarkData
          }, {
            name: 'Summit',
            header,
            data: summitData
          }],
          filename: 'Response Status Report'
        });
        this.downloadLoading = false;
      });
    },
    buildExcelData(surveyType) {
      const data = [];
      this.reportList.forEach((participant, index) => {
        const types = [{
          k: 'boss',
          v: 'Boss'
        }, {
          k: 'peer',
          v: 'Peer'
        }, {
          k: 'directReport',
          v: 'Direct Report'
        }];
        types.forEach(type => {
          const typeData = participant[surveyType + 'Survey'][type.k];
          if (typeData.length > 0) {
            typeData.forEach(typeDataItem => {
              data.push([participant.uuid, participant.name, participant.email, participant[surveyType + 'SurveyDone'] === 'Y' ? 'Yes' : 'No', (0, _filters.dateFormat)(participant[surveyType + 'SurveyCompletedTime'], 'YYYY-MM-DD HH:mm:ss'), type.v, typeDataItem.email, typeDataItem.isCompleted === 'Y' ? 'Yes' : 'No', (0, _filters.dateFormat)(typeDataItem.completedTime, 'YYYY-MM-DD HH:mm:ss')]);
            });
          } else {
            data.push([participant.uuid, participant.name, participant.email, participant[surveyType + 'SurveyDone'] === 'Y' ? 'Yes' : 'No', (0, _filters.dateFormat)(participant[surveyType + 'SurveyCompletedTime'], 'YYYY-MM-DD HH:mm:ss'), type.v, 'No Data', 'No Data', 'No Data']);
          }
        });
      });
      return data;
    }
  }
};